export default __webpack_public_path__ + "static/media/puesc-warning.2fa2a4f2.svg";